import { Suspense, lazy } from 'react';

import type { MapVenue } from '../../../../api/regions';
import { SectionCard } from '../../regional/BucketStates';

const RegionBoundaryMap = lazy(() =>
  import('./RegionBoundaryMap').then((m) => ({ default: m.RegionBoundaryMap })),
);

interface Props {
  boundary: GeoJSON.Geometry | null;
  draftAreas: unknown[];
  preview: unknown | null;
  color: string;
  venues: MapVenue[];
  addMode: boolean;
  onMapClick: (lat: number, lon: number) => void;
}

/** Left pane of the region builder: the lazy-loaded boundary map. */
export function BuilderMapPanel({
  boundary,
  draftAreas,
  preview,
  color,
  venues,
  addMode,
  onMapClick,
}: Props) {
  return (
    <SectionCard title="Area">
      <div style={{ height: 460 }}>
        <Suspense fallback={<div style={{ height: '100%' }} />}>
          <RegionBoundaryMap
            boundary={boundary}
            draftAreas={draftAreas}
            preview={preview}
            color={color}
            venues={venues}
            addMode={addMode}
            onMapClick={onMapClick}
          />
        </Suspense>
      </div>
    </SectionCard>
  );
}
